(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ivvi-ingredients-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.ivvi-ingredients-tabs');

    sections.forEach(function (section) {
      var tabs = Array.from(section.querySelectorAll('.ivvi-tab'));
      var panels = Array.from(section.querySelectorAll('.ivvi-tabs-panel'));
      var dots = Array.from(section.querySelectorAll('.ivvi-tabs-mobile-nav__dot'));
      var prevButton = section.querySelector('.ivvi-tabs-mobile-nav__arrow--prev');
      var nextButton = section.querySelector('.ivvi-tabs-mobile-nav__arrow--next');
      var mobileMedia = window.matchMedia('(max-width: 749px)');

      if (!tabs.length || !panels.length) return;

      var activeIndex = tabs.findIndex(function (tab) {
        return tab.getAttribute('aria-selected') === 'true';
      });

      if (activeIndex < 0) {
        activeIndex = 0;
      }

      var touchStartX = 0;

      function isMobile() {
        return mobileMedia.matches;
      }

      function updateTabs(index, moveFocus) {
        tabs.forEach(function (tab, tabIndex) {
          var isActive = tabIndex === index;

          tab.classList.toggle('tw:text-ivvi-text-black', isActive);
          tab.classList.toggle('tw:text-ivvi-text-gray', !isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');

          if (isActive && moveFocus) {
            tab.focus();
          }
        });
      }

      function updatePanels(index) {
        panels.forEach(function (panel, panelIndex) {
          var isActive = panelIndex === index;

          panel.classList.toggle('tw:hidden', !isActive);

          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }

      function updateMobileNav(index) {
        dots.forEach(function (dot, dotIndex) {
          var isActive = dotIndex === index;

          dot.classList.toggle('tw:bg-black', isActive);
          dot.classList.toggle('tw:bg-[#D9D9D9]', !isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        if (prevButton) {
          prevButton.disabled = index === 0;
        }

        if (nextButton) {
          nextButton.disabled = index === tabs.length - 1;
        }
      }

      function setActiveTab(index, options) {
        var moveFocus = options && options.moveFocus;

        if (index < 0 || index > tabs.length - 1) return;

        activeIndex = index;

        updateTabs(index, moveFocus);
        updatePanels(index);
        updateMobileNav(index);
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          setActiveTab(index);
        });

        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            setActiveTab((index + 1) % tabs.length, { moveFocus: true });
          }

          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            setActiveTab((index - 1 + tabs.length) % tabs.length, { moveFocus: true });
          }
        });
      });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = Number(dot.getAttribute('data-dot-index'));
          setActiveTab(index);
        });
      });

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          setActiveTab(activeIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          setActiveTab(activeIndex + 1);
        });
      }

      panels.forEach(function (panel) {
        panel.addEventListener(
          'touchstart',
          function (e) {
            if (!isMobile()) return;
            touchStartX = e.changedTouches[0].clientX;
          },
          { passive: true }
        );

        panel.addEventListener(
          'touchend',
          function (e) {
            if (!isMobile()) return;

            var touchEndX = e.changedTouches[0].clientX;
            var deltaX = touchStartX - touchEndX;

            if (Math.abs(deltaX) < 40) return;

            if (deltaX > 0) {
              setActiveTab(activeIndex + 1);
            } else {
              setActiveTab(activeIndex - 1);
            }
          },
          { passive: true }
        );
      });

      function handleBreakpointChange() {
        setActiveTab(activeIndex);
      }

      if (mobileMedia.addEventListener) {
        mobileMedia.addEventListener('change', handleBreakpointChange);
      } else if (mobileMedia.addListener) {
        mobileMedia.addListener(handleBreakpointChange);
      }

      setActiveTab(activeIndex);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ivvi-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('.ivvi-product-hero');
    if (!section) return;

    const thumbnails = section.querySelectorAll('.ivvi-product-hero__thumbnail');
    const mainImage = section.querySelector('.ivvi-product-hero__main-image');

    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbnails.forEach(function (t) {
          t.classList.remove('ivvi-product-hero__thumbnail--active', 'tw:border-ivvi-orange');
        });
        thumb.classList.add('ivvi-product-hero__thumbnail--active', 'tw:border-ivvi-orange');
        if (mainImage && thumb.dataset.imageUrl) {
          mainImage.src = thumb.dataset.imageUrl;
        }
      });
    });

    var purchaseOptions = section.querySelectorAll('[data-option]');
    var subscribeDetails = section.querySelector('[data-subscribe-details]');

    purchaseOptions.forEach(function (opt) {
      opt.addEventListener('change', function () {
        purchaseOptions.forEach(function (o) {
          o.classList.remove(
            'ivvi-product-hero__option--active',
            'ivvi-radio-active',
            'tw:border-2',
            'tw:border-ivvi-text-black',
            'tw:bg-ivvi-orange-light'
          );
          o.classList.add('tw:border', 'tw:border-ivvi-border-gray');
        });
        opt.classList.add(
          'ivvi-product-hero__option--active',
          'ivvi-radio-active',
          'tw:border-2',
          'tw:border-ivvi-text-black',
          'tw:bg-ivvi-orange-light'
        );
        opt.classList.remove('tw:border', 'tw:border-ivvi-border-gray');

        if (subscribeDetails) {
          subscribeDetails.hidden = opt.dataset.option !== 'subscribe';
        }
      });
    });

    var bottleOptions = section.querySelectorAll('.ivvi-product-hero__bottle');
    bottleOptions.forEach(function (bottle) {
      bottle.addEventListener('change', function () {
        bottleOptions.forEach(function (b) {
          b.classList.remove(
            'ivvi-product-hero__bottle--selected',
            'ivvi-bottle-selected',
            'tw:bg-ivvi-beige',
            'tw:border-ivvi-text-black'
          );
          b.classList.add('tw:border-ivvi-f1ecf5', 'tw:bg-white');
        });
        bottle.classList.add(
          'ivvi-product-hero__bottle--selected',
          'ivvi-bottle-selected',
          'tw:bg-ivvi-beige',
          'tw:border-ivvi-text-black'
        );
        bottle.classList.remove('tw:border-ivvi-f1ecf5', 'tw:bg-white');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
